/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_EmptyInputs */

const en_audit_empty = /** @type {(inputs: Audit_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No audit records found for the selected filters.`)
};

const pt_br2_audit_empty = /** @type {(inputs: Audit_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum registro de auditoria encontrado para os filtros selecionados.`)
};

/**
* | output |
* | --- |
* | "No audit records found for the selected filters." |
*
* @param {Audit_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_empty = /** @type {((inputs?: Audit_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_empty(inputs)
	return pt_br2_audit_empty(inputs)
});